<div class="box-continer">
  <ng-content></ng-content>
</div>
